import * as actionTypes from "../actionTypes";
import axios from "../../middleware/axios-api";
import { getErrors, getResData } from "../../shared/utility";

const cancelSubscriptionStart = () => {
  return {
    type: actionTypes.CANCEL_SUBSCRIPTION_START,
  };
};

const cancelSubscriptionSuccess = (cancelStatus: any) => {
  return {
    type: actionTypes.CANCEL_SUBSCRIPTION_START,
    cancelStatus,
  };
};

const cancelSubscriptionFailed = (error: any) => {
  return {
    type: actionTypes.CANCEL_SUBSCRIPTION_START,
    error,
  };
};

export const cancelSubscription = () => {};

const subscriptionStart = () => {
  return {
    type: actionTypes.SUBSCRIPTION_START,
  };
};

const subscriptionSuccess = (data: any) => {
  return {
    type: actionTypes.SUBSCRIPTION_SUCCESS,
    data,
  };
};

const subscriptionFailed = (error: any) => {
  return {
    type: actionTypes.SUBSCRIPTION_FAIL,
    error,
  };
};

export const telebirrSubscription = () => {
  return async (dispatch: any) => {
    dispatch(subscriptionStart());

    return axios
      .post(`/user/subscribe/telebirr`)
      .then((response) => {
        if (!response) throw new Error("No Response");

        const data = getResData(response.data);

        if (!data.success) throw new Error(getErrors(data));

        return dispatch(subscriptionSuccess(data));
      })
      .catch((err) => dispatch(subscriptionFailed(getErrors(err))));
  };
};

const getSubscriptionPlanDetailsStart = () => {
  return {
    type: actionTypes.SUBSCRIPTION_PLAN_DETAILS_START,
  };
};

const getSubscriptionPlanDetailsSuccess = (paymentInfo: any) => {
  return {
    type: actionTypes.SUBSCRIPTION_PLAN_DETAILS_SUCCESS,
    paymentInfo,
  };
};

const getSubscriptionPlanDetailsFailed = (error: any) => {
  return {
    type: actionTypes.SUBSCRIPTION_PLAN_DETAILS_FAIL,
    error,
  };
};

export const getSubscriptionPlanDetails = () => {
  return async (dispatch: any) => {
    dispatch(getSubscriptionPlanDetailsStart());

    return axios
      .get(`/subscription/aoc`)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));
          return dispatch(getSubscriptionPlanDetailsSuccess(data));
        }
      })
      .catch((err) =>
        dispatch(getSubscriptionPlanDetailsFailed(getErrors(err)))
      );
  };
};

const verifySubscriptionSuccess = (data: any) => {
  return {
    type: actionTypes.VERIFY_SUBSCRIPTION_SUCCESS,
    data: data.data,
  };
};

export const verifySubscription = () => {
  return async (dispatch: any) => {
    dispatch(subscriptionStart());

    return axios
      .get(`/user/subscription/data`)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));
          return dispatch(verifySubscriptionSuccess(data));
        }
      })
      .catch((err) => dispatch(subscriptionFailed(getErrors(err))));
  };
};

// ---------- Subscribe categories ---------- //
const subscribeCategoriesStart = () => {
  return {
    type: actionTypes.SUBSCRIBE_CATEGORIES_START,
  };
};

const subscribeCategoriesSuccess = (subscribeCategoriesStatus: any) => {
  return {
    type: actionTypes.SUBSCRIBE_CATEGORIES_SUCCESS,
    subscribeCategoriesStatus,
  };
};

const subscribeCategoriesFailed = (error: any) => {
  return {
    type: actionTypes.SUBSCRIBE_CATEGORIES_FAIL,
    error,
  };
};

export const subscribeCategories = (data: any) => {
  return async (dispatch: any) => {
    dispatch(subscribeCategoriesStart());

    return axios
      .post(`/buyer/category/subscription`,data)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));
          return dispatch(subscribeCategoriesSuccess(data));
        }
      })
      .catch((err) => dispatch(subscribeCategoriesFailed(getErrors(err))));
  };
};

export const unsubscribeCategories = (data: any) => {
  return axios
    .post(`/buyer/categories/unsubscribe`, data)
    .then((response) => {
      if (!response) throw new Error("No Response");

      const data = getResData(response.data);

      if (!data.success) throw new Error(getErrors(data));
      return data?.result;
    })
    .catch((err) => console.log(err));
};

// get SMS data for airtime subscription payment
const getSubscriptionSMSdataStart = () => {
  return {
    type: actionTypes.SUBSCRIPTION_SMS_DETAILS_START,
  };
}

const getSubscriptionSMSdataSuccess = (subscriptionSMSData:any) => {
  return {
    type: actionTypes.SUBSCRIPTION_SMS_DETAILS_SUCCESS,
    subscriptionSMSData,
  };
}
const getSubscriptionSMSdataFailed = (error:  any) => {
  return {
    type: actionTypes.SUBSCRIPTION_SMS_DETAILS_FAIL,
    error,
  };
}

export const getSubscriptionSMSdata = () => {
  return async (dispatch: any) => {
    dispatch(getSubscriptionSMSdataStart());

    return axios
      .get(`/subscription/metadata`)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));
          return dispatch(getSubscriptionSMSdataSuccess(data));
        }
      })
      .catch((err) =>
        dispatch(getSubscriptionSMSdataFailed(getErrors(err)))
      );
  };
};

// un subscribe using telebirr

const unsubscribeByTelebirrSuccess = (data: any) => {
  return {
    type: actionTypes.VERIFY_TELEBIRR_UN_SUBSCRIPTION_SUCCESS,
  };
};

export const unsubscribeByTelebirr = () => {
  return async (dispatch: any) => {
    dispatch(subscriptionStart());

    return axios
      .post(`/user/unsubscribe/telebirr`)
      .then((response) => {
        if (!response) throw new Error("No Response");
        if (response) {
          const data = getResData(response.data);
          if (!data.success) throw new Error(getErrors(data));
          return dispatch(unsubscribeByTelebirrSuccess(data));
        }
      })
      .catch((err) => dispatch(subscriptionFailed(getErrors(err))));
  };
};